import { render, staticRenderFns } from "./OpportunityListingOpen.vue?vue&type=template&id=0a20bed5&"
import script from "./OpportunityListingOpen.vue?vue&type=script&lang=js&"
export * from "./OpportunityListingOpen.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityListingOpen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports